'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _model = require('./model.service');

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var modelModule = _angular2.default.module('model.factory', []).factory('ModelFactory', _model2.default).name;

exports.default = modelModule;


// WEBPACK FOOTER //
// ./client/app/common/factories/modelFactory/model.js